import { useEffect, useRef } from 'react';
import handleTextReplacement from './handleTextReplacement';

export default function useReplacedInnerHtml(innerHtml: any) {
  const containerRef = useRef(null);
  const finalInnerHtml = handleTextReplacement(innerHtml);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.innerHTML = finalInnerHtml;
    }
  }, [finalInnerHtml]);

  return containerRef;
}
